export default {
    accessTokenStorageKey: 'accessToken',
    refreshTokenStorageKey: 'refreshToken',
    permissionsStorageKey: 'permissions',
};